export const MATERIAIS_DESCARTADOS_ATUALIZAR_DATA_INI = 'MATERIAIS_DESCARTADOS_ATUALIZAR_DATA_INI';
export const dataInicio = (dataInicio) => ({
  type: MATERIAIS_DESCARTADOS_ATUALIZAR_DATA_INI,
  payload: {
    dataInicio,
  },
});
export const MATERIAIS_DESCARTADOS_ATUALIZAR_DATA_FIM = 'MATERIAIS_DESCARTADOS_ATUALIZAR_DATA_FIM';
export const dataFim = (dataFim) => ({
  type: MATERIAIS_DESCARTADOS_ATUALIZAR_DATA_FIM,
  payload: {
    dataFim,
  },
});
export const MATERIAIS_DESCARTADOS_ATUALIZAR_FILTRO_VALUE = 'MATERIAIS_DESCARTADOS_ATUALIZAR_FILTRO_VALUE';
export const filtroValue = (filtroValue) => ({
  type: MATERIAIS_DESCARTADOS_ATUALIZAR_FILTRO_VALUE,
  payload: {
    filtroValue,
  },
});

export const MATERIAIS_DESCARTADOS_ATUALIZAR_LISTA = 'MATERIAIS_DESCARTADOS_ATUALIZAR_LISTA';
export const lista = (lista) => ({
  type: MATERIAIS_DESCARTADOS_ATUALIZAR_LISTA,
  payload: {
    lista,
  },
});
export const MATERIAIS_DESCARTADOS_ATUALIZAR_PAGE = 'MATERIAIS_DESCARTADOS_ATUALIZAR_PAGE';
export const page = (page) => ({
  type: MATERIAIS_DESCARTADOS_ATUALIZAR_PAGE,
  payload: {
    page,
  },
});
export const MATERIAIS_DESCARTADOS_ATUALIZAR_IMPRIMIR = 'MATERIAIS_DESCARTADOS_ATUALIZAR_IMPRIMIR';
export const imprimir = (imprimir) => ({
  type: MATERIAIS_DESCARTADOS_ATUALIZAR_IMPRIMIR,
  payload: {
    imprimir,
  },
});


// WEBPACK FOOTER //
// ./src/pages/descarte/tabs/materiais/store/materiais.action.js